import styled, {css} from 'styled-components'

import {Section, Layout} from '@/styles/grid'
import mq from '@/utils/media-query'

import type {Props} from './title-with-media-items'

export const Wrapper = styled(Section)`
    display: grid;
    grid-template-columns: 1fr;
    row-gap: ${({theme}) => theme.spacings.s20};

    ${mq.min('sm')} {
        row-gap: ${({theme}) => theme.spacings.s40};
    }
`

type ItemsProps = Pick<Props, 'variant'>

export const Items = styled(Layout)<ItemsProps>(({$variant}) => {
    const threeEqualMobileStyles = css`
        ${mq.max('sm')} {
            grid-template-columns: repeat(2, 1fr);
        }
    `

    return css`
        ${$variant === 'three-equal' && threeEqualMobileStyles}
    `
})
